import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

export default function ListAcara({ title, picture, date, time, url }) {
  const [imgSrc, setImgSrc] = useState(picture);
  const tanggal = new Date(date).toLocaleDateString("id", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <li className="col-span-1 flex h-full w-full flex-col justify-between  rounded-2xl bg-white p-3 font-nunito font-extrabold shadow-[0_4px_4px_0_rgba(0,0,0,0.2)] shadow-[#DCE5ED]/30">
      <div className="relative flex h-full w-full cursor-pointer items-center justify-center">
        <Image
          src={imgSrc ? imgSrc : setImgSrc("/images/logo.png")}
          alt={title}
          height={200}
          width={200}
          objectFit="contain"
          priority={true}
          title={title}
          onError={() => setImgSrc("/images/logo.png")}
        />
      </div>
      <div className="flex flex-col">
        <div className="h-16">
          <p className="hide-text mt-[14px] text-sm text-[#333333]">{title}</p>
        </div>
        <div className="mt-[10px] text-xs text-[#312e2e]">
          <p className="flex items-center gap-1">
            <span>
              <img
                src="/images/kalender.svg"
                alt="kalender"
                className="h-6 w-6"
              />
            </span>
            {tanggal}
          </p>
          <p className="flex items-center gap-1">
            <span>
              <img src="/images/jam.svg" alt="jam" className="h-6 w-6" />
            </span>
            {time} WIB
          </p>
        </div>
      </div>
      <div className="mt-[14px] flex items-center justify-center space-x-3 text-sm text-[#333333]">
        <Link href={`/acara/${url}`}>
          <button className="h-9 w-32 rounded-lg border-4 border-[#F0F0F0] bg-[#F0F0F0] text-[12px] font-extrabold hover:bg-[#228BE6] hover:text-white">
            Open
          </button>
        </Link>
      </div>
    </li>
  );
}
